import * as Yup from "yup"
import { transformSnakeToCamel, transformModelToJson } from "utils/transform"
import { PaginationSchema } from "model/_common"
import { LogSchema } from "model/_base"

// Yup Schemas
export const LogsSchema = Yup.object().shape({
  data: Yup.array().of(LogSchema),
  pagination: PaginationSchema,
})

export class LogsModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = LogsSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      })
      return model
    } catch (error) {
      throw error
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model)
  }
}
